import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CommonOptions, ModelDocumentsShow } from '../../../interfaces/interfaces';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { CropperComponent } from 'angular-cropperjs';
import { AuthService } from 'src/app/core/services/modules/auth.service';
import { User } from 'src/app/core/models/User';
import { EmployerService } from 'src/app/core/services/modules/employer.service';
import { FechasService } from 'src/app/core/services/utils/fechas.service';
import { CommonService } from 'src/app/core/services/modules/common.service';
import { SnackBarService } from 'src/app/core/services/utils/snackBar.service';
import {AuthGuardService} from '../../../services/guards/AuthGuardService';

export interface DialogData {
  title: string;
  docs: any;
  typeOperator: string;
  typeGestor: string;
  module: string;
  adminInfoId: string;
  isFromPersonal: boolean;
}

@Component({
  selector: 'app-dialog-gestor-documents',
  templateUrl: './dialog-gestor-documents.component.html',
  styleUrls: ['./dialog-gestor-documents.component.scss']
})
export class DialogGestorDocumentsComponent implements OnInit {
  @ViewChild('angularCropper') angularCropper: CropperComponent;

  state;
  userAuth: User;
  stateCurrent;
  file: File = null;
  permissionsModule;
  formFile: FormGroup;

  s3Bucket: string;
  email = '';
  module = '';
  imgCropper: string;
  commentary = '';
  stateString = '';
  imgCropperResult: string;
  cropper = false;

  DocsJSON: any = {};
  files: File[] = [];
  stories: any[] = [];
  documentos: any[] = [];
  permissions: string[] = [];
  proveedor: CommonOptions[] = [];
  lastStages: CommonOptions[] = [];
  permissionsCompany: string[] = [];

  date = new Date();
  formData = new FormData();
  minDate = new Date(this.date.getFullYear(), this.date.getMonth(), this.date.getDate());

  permissionsGestor: any[] = [
    { module: 'Personal',
      permissions: { uploadFile: 'documentinfopersonal.updatedate', upload: 'documentinfopersonal.upload', requestapproval: 'documentinfopersonal.requestapproval', approval: 'documentinfopersonal.approval'}
    },
    { module: 'Employer',
      permissions: { uploadFile: 'documentinfoemployer.updatedate', upload: 'documentinfoemployer.upload', requestapproval: 'documentinfoemployer.requestapproval', approval: 'documentinfoemployer.approval'}
    },
    { module: 'SocialSecurity',
      permissions: { uploadFile: 'documentinfosocialsecurity.uploadFile', upload: 'documentinfosocialsecurity.upload', requestapproval: 'documentinfosocialsecurity.requestapproval', approval: 'documentinfosocialsecurity.approval'}
    }];

  constructor(
    private dialogRef: MatDialogRef<DialogGestorDocumentsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private fb: FormBuilder,
    private authService: AuthService,
    private authGuardService: AuthGuardService,
    private employerService: EmployerService,
    private fechasService: FechasService,
    private commonService: CommonService,
    private snackBService: SnackBarService,
  ) {
    this.userAuth = this.authService.getUser();
    this.permissions = this.userAuth.claims;
    this.email = this.userAuth?.Email !== null && this.userAuth?.Email !== undefined ? this.userAuth?.Email : '';
    this.formFile = this.fb.group({
      File: '',
      Date: ''
    });
    this.module = this.data.module;
    // selected permisions
    this.permissionsModule = this.permissionsGestor.find(x => x.module === this.module);
    this.stateCurrent = this.data.docs;
    this.state = this.stateCurrent.State;
    if (this.data?.docs?.Id !== undefined) {
      this.employerService.getDocumentInfoEmployerHistorical(this.data?.docs?.Id).subscribe(rest => {
        if (rest !== null && rest.length !== 0) {
          this.stateCurrent = rest[rest.length - 1];
        }
        this.stories = rest.sort((a, b) => a.UpdateDate < b.UpdateDate ? 1 : -1);
      });
    }

    this.commonService.getCommonOptions('PersonalContractStage').subscribe((options: CommonOptions[]) => {
        this.lastStages = options;

        if (this.state !== undefined) {
          const selectedStage = this.lastStages.find(x => x.Value === this.state);
          this.stateString = selectedStage?.Description?.toLocaleUpperCase() || '';
        }
      });

    // Fecha state current
    if (this.data.docs.StateId !== null && this.data.docs.StateId !== '' && this.data.docs.StateId !== undefined) {
      this.formFile.get('Date').setValue(this.stateCurrent?.Date);
    }
   }

  ngOnInit(): void {
    this.s3Bucket = environment.api.s3Bucket;
    this.getInfoAdmin();
  }

  getInfoAdmin() {
    this.permissionsCompany = this.authGuardService.auth.getUser().Companies.find(x => x.Id === this.data.adminInfoId).Permissions;
  }

  exitPermissionCompany(permiso: string): boolean {
    let exit: boolean;
    const permisionsUserInfo  = this.permissionsCompany.find(x => x === permiso);
    permisionsUserInfo !== undefined ? exit = true : exit = false;
    return exit;
  }

  // Estos permisos es para ver los campos a editar archivos fecha comentarios
  exitPermissionView(): boolean {
    let exit = false;
    // Permiso sin estado para iniciar una solictud
    if ((this.data?.docs?.State === undefined || this.data?.docs?.State === 'REC')
        && this.exitPermission(this.permissionsModule.permissions.requestapproval)) {
      exit = true;
    }
    // permiso para aprovar una solicitud
    if (this.data?.docs?.State === 'SOL' && this.exitPermission(this.permissionsModule.permissions.approval)) {
      exit = true;
    }
    return exit;
  }

  getCalculateStateDateWithHORA(date, id?): string {
    let response = '';
    response = this.fechasService.calculateStateDateWithHORA(date, id);
    return response;
  }

  getDateFormatR(date): string {
    let response = '';
    if (date !== null && date !== null) {
      response = this.fechasService.getDateFormatR(date);
    }
    return response;
  }

  getDateFormatRMinutes(date): string {
    let response: string;
    response = this.fechasService.getDateFormatRMinutes(date);
    return response;
  }

  openImgVideoUrl(url: any) {
    window.open(this.s3Bucket + url, '_blank');
  }

  onNoClick(): void {
    this.dialogRef.close(false);
  }

  jsonUpdateDeleteDoc(doc: ModelDocumentsShow, index) {
    const DocsJSON = `{"${doc.name}": "${doc.urlDoc}"}`;
    const a = JSON.parse(DocsJSON);
    Object.assign(this.DocsJSON, a);
    delete this.documentos[index];
  }

  private isAllowed(f: File): boolean {
    return ['application/pdf', 'image/jpg', 'image/jpeg', 'image/png'].includes(f?.type) &&
      /\.(pdf|jpg|jpeg|png)$/i.test((f?.name || '').toLowerCase());
  }

  // METODOS PARA CORTAR UNA IMAGEN Y GUARDARLA
  onSelect(event: { addedFiles: File[], rejectedFiles?: File[] }): void {
    const maxFileSize = 10 * 1024 * 1024;
    this.files = [];

    let selectedFiles: File[] = event.addedFiles || [];

    if (File) {
      const badFormat = selectedFiles.filter(f => !this.isAllowed(f));
      if (badFormat.length) {
        this.snackBService.openWarning('Solo se permite subir archivos en formatos PDF, JPG, PNG.', '', 5000);
      }
      selectedFiles = selectedFiles.filter(f => this.isAllowed(f));
    }

    const tooBig = selectedFiles.filter(f => f.size > maxFileSize);
    if (tooBig.length) {
      this.snackBService.openWarning('El archivo supera el peso máximo permitido de 10 MB', '', 5000);
    }
    const finalFiles = selectedFiles.filter(f => f.size <= maxFileSize);

    if (this.cropper === false) {
      for (const file of finalFiles) {
        this.files.push(file);
      }
    } else if (
      this.cropper === true &&
      (this.data.typeOperator === 'showDelete' || this.data.typeOperator === 'showUpdate')
    ) {
      for (const file of finalFiles) {
        this.files.push(file);
      }
    } else {
      const reader = new FileReader();
      if (finalFiles[0]) {
        reader.readAsDataURL(finalFiles[0]);
        reader.onload = () => {
          this.imgCropper = reader.result as string;
          this.imgCropperResult = reader.result as string;
        };
      }
    }
  }

  isEqualsUserRemoveFile(doc): boolean {
    let equal = false;
    this.userAuth.username === doc?.user ? equal = true : equal = false;
    return equal;
  }

  // METODOS PARA CORTAR UNA IMAGEN Y GUARDARLA FIN

  removeFile(index) {
    this.files.splice(index, 1);
  }

  getState(state): number {
    let idStage = 0;
    this.lastStages.forEach((stage: CommonOptions) => {
      if (stage.Value === state) {
        idStage = stage.Id;
      }
    });
    return idStage;
  }

  solicitar() {
    const id = this.getState('SOL');
    let model;
    if (this.module === 'Personal') {
      model = {
        PersonalCompanyInfoId: this.data?.docs?.PersonalCompanyInfoId,
        EmployerInfoId: this.data?.docs?.EmployerInfoId,
        Date: this.formFile.get('Date').value,
        RequirementId: this.stateCurrent.RequirementId,
        StateId: id,
        Comments: this.commentary === null || this.commentary === '' ? this.stateCurrent.Comments : this.commentary
      };
    } else if (this.module === 'Employer') {
      model = {
        EmployerInfoId: this.data?.docs?.EmployerInfoId,
        Date: this.formFile.get('Date').value,
        RequirementId: this.stateCurrent.RequirementId,
        StateId: id,
        Comments: this.commentary === null || this.commentary === '' ? this.stateCurrent.Comments : this.commentary
      };
    } else if (this.module === 'SocialSecurity') {
      model = {
        SocialSecurityId: this.data?.docs?.State === undefined ? this.stateCurrent.SocialSecurityId :
          this.stateCurrent.ExternalRequirementId,
        Date: this.formFile.get('Date').value,
        StateId: id,
        Comments: this.commentary === null || this.commentary === '' ? this.stateCurrent.Comments : this.commentary
      };
    }
    this.employerService.postDocumentInfo(model, this.module).subscribe((rest: any) => {
      if (this.files.length !== 0) {
        const formData = new FormData();
        formData.append('File', this.files[0]);
        this.employerService.putDocumentInfoFile(rest.Id, formData).subscribe(() => {
          this.dialogRef.close(true);
        });
      } else {
        this.dialogRef.close(true);
      }
    });
  }

  aprobar() {
    if ((this.formFile.get('Date').value === '' ||
      this.formFile.get('Date').value === null ||
      this.formFile.get('Date').value === undefined) &&
      this.module !== 'SocialSecurity' &&
      this.exitPermission(this.permissionsModule.permissions.uploadFile) && this.stateCurrent.ByDate === true) {
      this.snackBService.openWarning('POR FAVOR DIGITAR FECHA DE VENCIMIENTO', '', 3000);
    } else {
      const id = this.getState('APR');
      let model;
      if (this.module === 'Personal') {
        model = {
          PersonalCompanyInfoId: this.data?.docs?.PersonalCompanyInfoId,
          EmployerInfoId: this.data?.docs?.EmployerInfoId,
          Date: this.formFile.get('Date').value,
          RequirementId: this.stateCurrent.RequirementId,
          StateId: id,
          Comments: this.commentary === null || this.commentary === '' ? this.stateCurrent.Comments : this.commentary
        };
      } else if (this.module === 'Employer') {
        model = {
          EmployerInfoId: this.data?.docs?.EmployerInfoId,
          Date: this.formFile.get('Date').value,
          RequirementId: this.stateCurrent.RequirementId,
          StateId: id,
          Comments: this.commentary === null || this.commentary === '' ? this.stateCurrent.Comments : this.commentary
        };
      } else if (this.module === 'SocialSecurity') {
        model = {
          SocialSecurityId: this.stateCurrent.ExternalRequirementId,
          Date: this.formFile.get('Date').value,
          StateId: id,
          Comments: this.commentary === null || this.commentary === '' ? this.stateCurrent.Comments : this.commentary
        };
      }

      if (this.files.length !== 0) {
        const formData = new FormData();
        formData.append('File', this.files[0]);
        this.employerService.putDocumentInfoFile(this.stateCurrent.DocumentInfoId, formData).subscribe(rest => {
          this.employerService.postDocumentInfo(model, this.module).subscribe(() => {
            this.dialogRef.close(true);
          });
        });
      } else {
        this.employerService.postDocumentInfo(model, this.module).subscribe(() => {
          this.dialogRef.close(true);
        });
      }
    }
  }

  rechazar() {
    const id = this.getState('REC');
    let model;
    if (this.module === 'Personal') {
      model = {
        PersonalCompanyInfoId: this.data?.docs?.PersonalCompanyInfoId,
        EmployerInfoId: this.data?.docs?.EmployerInfoId,
        Date: this.formFile.get('Date').value,
        RequirementId: this.stateCurrent.RequirementId,
        StateId: id,
        Comments: this.commentary === null || this.commentary === '' ? this.stateCurrent.Comments : this.commentary
      };
    } else if (this.module === 'Employer') {
      model = {
        EmployerInfoId: this.data?.docs?.EmployerInfoId,
        Date: this.formFile.get('Date').value,
        RequirementId: this.stateCurrent.RequirementId,
        StateId: id,
        Comments: this.commentary === null || this.commentary === '' ? this.stateCurrent.Comments : this.commentary
      };
    } else if (this.module === 'SocialSecurity') {
      model = {
        SocialSecurityId: this.stateCurrent.ExternalRequirementId,
        Date: this.formFile.get('Date').value,
        StateId: id,
        Comments: this.commentary === null || this.commentary === '' ? this.stateCurrent.Comments : this.commentary
      };
    }

    if (this.files.length !== 0) {
      const formData = new FormData();
      formData.append('File', this.files[0]);
      this.employerService.putDocumentInfoFile(this.stateCurrent.DocumentInfoId, formData).subscribe(rest => {
        this.employerService.postDocumentInfo(model, this.module).subscribe(() => {
          this.dialogRef.close(true);
        });
      });
    } else {
      this.employerService.postDocumentInfo(model, this.module).subscribe(rest => {
        this.dialogRef.close(true);
      });
    }
  }

  exitPermission(permiso: string): boolean {
    let exit: boolean;
    const permisionsUserInfo  = this.permissions.find(x => x === permiso);
    permisionsUserInfo !== undefined ? exit = true : exit = false;
    return exit;
  }


}

